import { Component, OnInit } from '@angular/core';

 import {session} from '../../../../environments/environment.session'
  @Component({
  selector: '[app-vms-footer]',
  templateUrl: './vms-footer.component.html',
  styleUrls: ['./vms-footer.component.css']
})
export class VmsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
